
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3d2EW", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $4550e48693be1fb4$export$a7357cdd1f0b0168);
$parcel$export(module.exports, "EllipsisDropdownComponent", () => $4550e48693be1fb4$export$82d507aca0e648e3);
/* EllipsisDropdown.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $ipPpS = parcelRequire("ipPpS");

var $inPa6 = parcelRequire("inPa6");

var $dAYOx = parcelRequire("dAYOx");
var $ahaN7 = parcelRequire("ahaN7");

var $5izcQ = parcelRequire("5izcQ");

var $5fMeR = parcelRequire("5fMeR");

var $3mVfX = parcelRequire("3mVfX");

var $kqvQA = parcelRequire("kqvQA");

var $2kB0r = parcelRequire("2kB0r");
var $4wEOc = parcelRequire("4wEOc");

var $bbp3G = parcelRequire("bbp3G");

var $ayQVU = parcelRequire("ayQVU");

var $b66o6 = parcelRequire("b66o6");

var $v1jQ6 = parcelRequire("v1jQ6");

var $dIouf = parcelRequire("dIouf");

var $6mKj3 = parcelRequire("6mKj3");

var $9wGTI = parcelRequire("9wGTI");

var $7aRa9 = parcelRequire("7aRa9");

var $hp2SH = parcelRequire("hp2SH");
var $7Sm4c = parcelRequire("7Sm4c");

var $k0pnk = parcelRequire("k0pnk");

var $BCkug = parcelRequire("BCkug");

var $gTyTP = parcelRequire("gTyTP");

var $jmjWc = parcelRequire("jmjWc");

var $5ZqQS = parcelRequire("5ZqQS");

var $1NBp8 = parcelRequire("1NBp8");

var $flE5X = parcelRequire("flE5X");

var $dZ4NH = parcelRequire("dZ4NH");

var $dPJCf = parcelRequire("dPJCf");

var $ljm2R = parcelRequire("ljm2R");

var $l3C2L = parcelRequire("l3C2L");

var $6ld6a = parcelRequire("6ld6a");

var $5SlMo = parcelRequire("5SlMo");

var $8Bp0j = parcelRequire("8Bp0j");

var $6DX3n = parcelRequire("6DX3n");

var $iQb1R = parcelRequire("iQb1R");

var $b6AjJ = parcelRequire("b6AjJ");
function $4550e48693be1fb4$var$_defineProperty(e, r, t) {
    return (r = $4550e48693be1fb4$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4550e48693be1fb4$var$_toPropertyKey(t) {
    var i = $4550e48693be1fb4$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4550e48693be1fb4$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $4550e48693be1fb4$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    preview: {
        id: "editor-ellipsis-dropdown.preview",
        defaultMessage: "Preview"
    },
    templateDocs: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.templates",
        defaultMessage: "Templates"
    },
    addLabels: {
        id: "editor-ellipsis-dropdown.open.ellipsis.edit.labels",
        defaultMessage: "Add labels"
    },
    deleteUnpublishedPage: {
        id: "editor-ellipsis-dropdown.open.ellipsis.page.delete",
        defaultMessage: "Delete unpublished page"
    },
    deleteUnpublishedBlogpost: {
        id: "editor-ellipsis-dropdown.open.ellipsis.blogpost.delete",
        defaultMessage: "Delete unpublished blog post"
    },
    revert: {
        id: "editor-ellipsis-dropdown.open.ellipsis.revert",
        defaultMessage: "Revert to previous version"
    },
    updateWithoutNotifying: {
        id: "editor-ellipsis-dropdown.open.ellipsis.update.without.notify",
        defaultMessage: "Update without notifying watchers"
    },
    openTemplateBrowser: {
        id: "editor-ellipsis-dropdown.open.template.browser",
        defaultMessage: "Open template browser"
    },
    revertEditor: {
        id: "editor-ellipsis-dropdown.open.ellipsis.revert.editor",
        defaultMessage: "Revert to legacy editor"
    },
    undo: {
        id: "editor-ellipsis-dropdown.open.ellipsis.editor.undo",
        defaultMessage: "Undo"
    },
    redo: {
        id: "editor-ellipsis-dropdown.open.ellipsis.editor.redo",
        defaultMessage: "Redo"
    },
    findReplace: {
        id: "editor-ellipsis-dropdown.open.ellipsis.editor.find.replace",
        defaultMessage: "Find and replace"
    }
});

const $4550e48693be1fb4$var$LivePagesExpandedEapConversionSpotlightLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "n_f6X",
    name: "LivePagesExpandedEapConversionSpotlightLoader",
    loader: async ()=>(await (parcelRequire("aFeyZ"))).LivePagesExpandedEapConversionSpotlight
});
const $4550e48693be1fb4$var$noop = ()=>{}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4550e48693be1fb4$var$MenuItemContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $4550e48693be1fb4$var$previewPage = (createAnalyticsEvent, onPreviewClicked, contentId, contentType)=>{
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'previewPage',
            source: 'ellipsisDropdownComponent',
            objectId: contentId,
            objectType: contentType
        }
    }).fire();
    onPreviewClicked(false);
};
const $4550e48693be1fb4$var$publishWithoutNotify = (createAnalyticsEvent, onClickPublish, contentId, contentType)=>{
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'publishWithoutNotifyFromOverflow',
            source: 'ellipsisDropdownComponent',
            objectId: contentId,
            objectType: contentType
        }
    }).fire();
    onClickPublish({
        suppressNotifyWatchers: true
    })();
};
class $4550e48693be1fb4$var$EllipsisDropdownClass extends (0, $gwFzn.PureComponent) {
    componentDidMount() {
        this.setEditorProperty();
    }
    /**
   * Menu items are pushed into the 'items' list which is used to create the '•••' menu
   * (aka more aka ellipsis aka meatball) for editor pages
   */ _getItems(dialogs) {
        const { addCompanyHubSettingsGroupMenuItems: addCompanyHubSettingsGroupMenuItems, contentType: contentType, isDisabled: isDisabled, isUnpublishedDraft: isUnpublishedDraft, showRevertDialog: showRevertDialog, spaceKey: spaceKey, contentId: contentId, isContentCreationPanelShown: isContentCreationPanelShown, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, onClickPublish: onClickPublish, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, onPreviewClicked: onPreviewClicked, createAnalyticsEvent: createAnalyticsEvent, isImportDisabled: isImportDisabled, push: push, saveDraft: saveDraft, switchToLivePage: switchToLivePage, showCommentsPanel: showCommentsPanel, hasEditPermission: hasEditPermission, editorActions: editorActions } = this.props;
        if (this.state.isMenuOpen) createAnalyticsEvent?.({
            type: 'sendScreenEvent',
            data: {
                name: 'ellipsisDropdownForMoreItems'
            }
        }).fire();
         // Don't want to trigger exposures when users open the ellipsis dropdown we are
        // just disabling an item that is not required for the experiment
        // The exposure will happen when the user converts a page instead
        const [onEditConvertExp] = (0, $6mKj3.UNSAFE_noExposureExp)('platform_editor_on_edit_convert');
        const addPreviewMenuItem = (menuItems)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: "preview",
                onClick: ()=>{
                    $4550e48693be1fb4$var$previewPage(createAnalyticsEvent, onPreviewClicked, contentId, contentType);
                },
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
                    shortcut: (0, $ljm2R.EDITOR2_SHORTCUTS).PREVIEW
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.preview)));
        };
        const showViewChangesDialog = ()=>dialogs.showDialog((0, $l3C2L.ViewChangesDialogLoader), {
                contentId: contentId
            });
        const addViewChangesMenuItem = (menuItems)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: "view-changes",
                onClick: this.saveDraftAnd(showViewChangesDialog)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $6DX3n.i18n).viewChanges)));
        };
        const addTemplateBrowserMenuItem = (menuItems)=>{
            const label = isImportDisabled ? $4550e48693be1fb4$export$a7357cdd1f0b0168.templateDocs : (0, $6DX3n.i18n).templateImportDocs;
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: "open-template-browser",
                onClick: onClickOpenContentCreationPanel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), label)));
        };
        const addClassifyContentMenuItem = (menuItems)=>{
            if (this.props.isClassificationEnabled) menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2kB0r.EllipsisClassificationMenuItem), null));
        };
        const addEditLabelsMenuItem = (menuItems)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $k0pnk.EditLabelDropdownItem), {
                contentId: contentId || '',
                spaceKey: spaceKey,
                dialogs: dialogs
            }));
        };
        const addMovePageMenuItem = (menuItems, movePageContentId, movePageSpaceKey)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $v1jQ6.EditorMovePageButtonLoader), {
                contentId: movePageContentId,
                spaceKey: movePageSpaceKey,
                appearance: "dropdownItem",
                analyticsSource: "EllipsisDropdownComponent",
                key: "move-page-button",
                retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                isUnpublishedDraft: !!isUnpublishedDraft
            }));
        };
        const addResolvedCommentsMenuItem = (menuItems, contentId, spaceKey)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: "resolved-comments",
                onClick: ()=>{
                    if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                        showCommentsPanel({
                            openWithView: (0, $3mVfX.ViewValues).RESOLVED
                        });
                        return;
                    }
                    dialogs.showDialog((0, $dZ4NH.ResolvedInlineCommentsDialogLoader), {
                        spaceKey: spaceKey,
                        contentId: contentId,
                        context: 'editor'
                    });
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4550e48693be1fb4$var$MenuItemContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $6DX3n.i18n).resolvedComments), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dZ4NH.ResolvedInlineCommentsCounterLoader), {
                contentId: contentId
            }))));
        };
        const addDeleteChangesMenuItem = (menuItems)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: "delete-changes",
                onClick: this.saveDraftAnd(showRevertDialog)
            }, isUnpublishedDraft && contentType === 'page' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.deleteUnpublishedPage) : null, isUnpublishedDraft && contentType !== 'page' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.deleteUnpublishedBlogpost) : null, !isUnpublishedDraft ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.revert) : null));
        };
        const addSwitchToLiveEditMenuItem = ({ menuItems: menuItemsArg })=>{
            if (this.props.isLivePagesEnabled && contentType === 'page') {
                const switchToLiveEditWebItem = this.props.webItems?.find((item)=>item.id === 'action-switch-to-live-edit');
                if (!switchToLiveEditWebItem) return;
                menuItemsArg.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                    key: "switch-to-live-edit",
                    onClick: switchToLivePage
                }, switchToLiveEditWebItem.label));
            }
        };
        const addPublishGroupMenuItems = (menuItems)=>{
            const publishGroupItems = [];
            if (this.isAllowed((0, $iQb1R.Buttons).SWITCH_TO_LIVE_EDIT) && contentId) {
                if (!isUnpublishedDraft) addSwitchToLiveEditMenuItem({
                    menuItems: publishGroupItems
                });
                else if (saveDraft && (0, $9wGTI.fg)('confluence_live_pages_switch_draft_to_live_page')) addSwitchToLiveEditMenuItem({
                    menuItems: publishGroupItems
                });
            }
            if (!isUnpublishedDraft) this.isAllowed((0, $iQb1R.Buttons).PUBLISH_WITHOUT_NOTIFY) && publishGroupItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: "publish-without-notify",
                isDisabled: isDisabled,
                onClick: ()=>{
                    $4550e48693be1fb4$var$publishWithoutNotify(createAnalyticsEvent, onClickPublish, contentId, contentType);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.updateWithoutNotifying)));
            publishGroupItems.length !== 0 && menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
                "data-testid": "publish-group-items",
                key: "publish-group-items"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ahaN7.default), null, publishGroupItems)));
            return publishGroupItems.length;
        };
        const addOtherGroupMenuItems = (menuItems)=>{
            const otherGroupItems = [];
            this.isAllowed((0, $iQb1R.Buttons).PREVIEW) && addPreviewMenuItem(otherGroupItems);
            if (!isUnpublishedDraft && this.isAllowed((0, $iQb1R.Buttons).VIEW_CHANGES)) addViewChangesMenuItem(otherGroupItems);
             // Show option to expose the page template menu that pops out from the side
            if (shouldShowOpenContentCreationMenuItem && this.isAllowed((0, $iQb1R.Buttons).TEMPLATE_BROWSER)) addTemplateBrowserMenuItem(otherGroupItems);
            if (contentId && spaceKey) {
                this.isAllowed((0, $iQb1R.Buttons).CLASSIFY_CONTENT) && addClassifyContentMenuItem(otherGroupItems);
                this.isAllowed((0, $iQb1R.Buttons).EDIT_LABELS) && addEditLabelsMenuItem(otherGroupItems);
                this.isAllowed((0, $iQb1R.Buttons).MOVE_PAGE) && addMovePageMenuItem(otherGroupItems, contentId, spaceKey);
                this.isAllowed((0, $iQb1R.Buttons).RESOLVED_COMMENTS) && addResolvedCommentsMenuItem(otherGroupItems, contentId, spaceKey);
            } // Empty title needed to maintain blank line above group
            otherGroupItems.length !== 0 && menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
                "data-testid": "other-group-items",
                key: "other-group-items"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ahaN7.default), {
                hasSeparator: menuItems.length >= 1
            }, otherGroupItems)));
        };
        const addEditorActionsGroupMenuItems = (menuItems)=>{
            const editorActionsGroupItems = [];
            const isAllowed = (contentType === 'page' || contentType === 'blogpost') && hasEditPermission;
            if (!isAllowed || !editorActions) return;
            const { canUndo: editorCanUndo, canRedo: editorCanRedo, undo: editorUndo, redo: editorRedo, activateFindReplace: editorActivateFindReplace } = editorActions;
            if (!!editorUndo) editorActionsGroupItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: "editor-undo",
                isDisabled: !editorCanUndo,
                onClick: ()=>{
                    editorUndo?.();
                },
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
                    shortcut: (0, $ljm2R.EDITOR2_SHORTCUTS).UNDO
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.undo)));
            if (!!editorRedo) editorActionsGroupItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: "editor-redo",
                isDisabled: !editorCanRedo,
                onClick: ()=>{
                    editorRedo?.();
                },
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
                    shortcut: (0, $ljm2R.EDITOR2_SHORTCUTS).REDO
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.redo)));
            if (!!editorActivateFindReplace) editorActionsGroupItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: "editor-find-replace",
                onClick: ()=>{
                    editorActivateFindReplace?.();
                },
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
                    shortcut: (0, $ljm2R.EDITOR2_SHORTCUTS).FIND_REPLACE
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.findReplace)));
            editorActionsGroupItems.length !== 0 && menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
                "data-testid": "editor-actions-group-items",
                key: "editor-actions-group-items"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ahaN7.default), {
                hasSeparator: menuItems.length >= 1
            }, editorActionsGroupItems)));
        };
        const showRevertEditorDialog = ()=>{
            dialogs.showDialog((0, $b66o6.RevertEditorDialog), {
                contentId: contentId,
                onPageRevert: ()=>(0, $8Bp0j.onClickPageRevert)(push, contentType, spaceKey, contentId)
            });
        };
        const addRevertToLegacyEditor = (menuItems)=>{
            menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: "revert-editor",
                onClick: this.saveDraftAnd(showRevertEditorDialog)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $4550e48693be1fb4$export$a7357cdd1f0b0168.revertEditor)));
        };
        const addDiscardGroupMenuItems = (menuItems)=>{
            const discardGroupItems = [];
            if (this.isAllowed((0, $iQb1R.Buttons).DELETE_DRAFT)) {
                addDeleteChangesMenuItem(discardGroupItems);
                this.state.isPageAutoconverted && ((0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? true : !onEditConvertExp.get('isEnabled', false)) && addRevertToLegacyEditor(discardGroupItems);
            } // Empty title needed to maintain blank line above group
            discardGroupItems.length !== 0 && menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
                "data-testid": "discard-group-items",
                key: "discard-group-items"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ahaN7.default), {
                hasSeparator: menuItems.length >= 1
            }, discardGroupItems)));
        };
        const shouldShowOpenContentCreationMenuItem = !isContentCreationPanelShown && isUnpublishedDraft && contentType === 'page';
        const menuItems = []; /**
                                            * Menu items are separated into three groups: publish, other and discard
                                            * Use the allowedEllipsisButtons array to filter for buttons needed to be rendered
                                            */ 
        addPublishGroupMenuItems(menuItems);
        addEditorActionsGroupMenuItems(menuItems);
        addOtherGroupMenuItems(menuItems);
        addDiscardGroupMenuItems(menuItems);
        addCompanyHubSettingsGroupMenuItems(menuItems);
        return menuItems;
    }
    render() {
        const { isDisabled: isDisabled, tooltipDisabledState: tooltipDisabledState, isLivePagesEnabled: isLivePagesEnabled, contentType: contentType, isUnpublishedDraft: isUnpublishedDraft } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
            to: [
                (0, $bbp3G.DialogsStateContainer)
            ]
        }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, isLivePagesEnabled && contentType === 'page' && !isUnpublishedDraft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4550e48693be1fb4$var$LivePagesExpandedEapConversionSpotlightLoader, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
                name: "live-pages-expanded-eap-changeboarding-convert-to-live"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
                "data-testid": "ellipsis-menu"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5SlMo.CommonDropdownMenu), {
                isMenuOpen: this.state.isMenuOpen,
                handleMenuOpenChange: this.handleMenuOpenChange,
                isDisabled: isDisabled,
                tooltipDisabledState: tooltipDisabledState
            }, this._getItems(dialogs))))));
    }
    constructor(...args){
        super(...args);
        $4550e48693be1fb4$var$_defineProperty(this, "context", void 0);
        $4550e48693be1fb4$var$_defineProperty(this, "state", {
            isMenuOpen: this.props.isInitialMenuOpen,
            isPageAutoconverted: false
        }); /**
         * Set editor property state
         * @returns {Promise<void>}
         */ 
        $4550e48693be1fb4$var$_defineProperty(this, "setEditorProperty", async ()=>{
            const { contentId: contentId } = this.props;
            const { data: contentPropertiesData } = await (0, $hp2SH.getApolloClient)().query({
                query: (0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? (0, $kqvQA.ContentPropertiesQueryWithBodyRepresentation) : (0, $kqvQA.ContentPropertiesQuery),
                variables: {
                    contentId: contentId
                }
            }).catch((e)=>{
                if ((0, $dIouf.isUnauthorizedError)(e) || (0, $flE5X.containsNoNetworkError)(e)) (0, $7Sm4c.markErrorAsHandled)(e);
                else (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    attribution: (0, $dIouf.Attribution).BACKBONE
                });
                return {
                    data: null
                };
            });
            if (contentPropertiesData) {
                const { editorProperty: editorProperty, isAutoConverted: isAutoConverted } = (0, $ayQVU.getAutoConvertionInfo)(contentPropertiesData?.content?.nodes?.[0]);
                const isNewPage = contentPropertiesData?.content?.nodes?.length === 0;
                this.setState({
                    isPageAutoconverted: ((0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? !!isAutoConverted : !editorProperty) && !isNewPage
                });
            }
        });
        $4550e48693be1fb4$var$_defineProperty(this, "saveDraftAnd", (afterSaveDraftDispatched)=>()=>{
                if (this.props.saveDraft) this.props.saveDraft();
                afterSaveDraftDispatched();
            }); // when allowed ellipsis buttons is undefined, enable all buttons
        $4550e48693be1fb4$var$_defineProperty(this, "isAllowed", (menuItem)=>this.props.allowedEllipsisButtons?.includes(menuItem) ?? true);
        $4550e48693be1fb4$var$_defineProperty(this, "handleMenuOpenChange", (attrs)=>this.setState({
                isMenuOpen: attrs.isOpen
            }));
    }
}
$4550e48693be1fb4$var$_defineProperty($4550e48693be1fb4$var$EllipsisDropdownClass, "displayName", 'EllipsisDropdown');
$4550e48693be1fb4$var$_defineProperty($4550e48693be1fb4$var$EllipsisDropdownClass, "defaultProps", {
    saveDraft: $4550e48693be1fb4$var$noop,
    isDisabled: false,
    isInitialMenuOpen: false
});
const $4550e48693be1fb4$export$82d507aca0e648e3 = (0, $7aRa9.withFlags)((props)=>{
    const addCompanyHubSettingsGroupMenuItems = (0, $b6AjJ.useCompanyHubSettingsGroupMenuItems)(props);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isEnabled: isClassificationEnabled } = (0, $4wEOc.useIsDataClassificationEnabledForOrg)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const webItemLocation = (0, $6ld6a.useWebItemLocation)({
        location: 'system.content.action',
        contentId: props.contentId
    });
    const switchToLivePage = (0, $BCkug.useSwitchToLivePage)({
        contentId: props.contentId,
        spaceId: props.spaceId,
        isUnpublishedDraft: !!props.isUnpublishedDraft,
        flags: props.flags,
        retrieveEditorTitleAndContent: props.retrieveEditorTitleAndContent,
        saveDraft: props.saveDraft,
        analyticsSource: 'ellipsisDropdownComponent',
        adfOrigin: 'EDITOR',
        onSuccessfulConversion: ()=>{
            // Redirect to the route for the new live page.
            push((0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: props.spaceKey,
                contentId: props.contentId
            }));
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4550e48693be1fb4$var$EllipsisDropdownClass, {
        ...props,
        addCompanyHubSettingsGroupMenuItems: addCompanyHubSettingsGroupMenuItems,
        createAnalyticsEvent: createAnalyticsEvent,
        isLivePagesEnabled: isLivePagesFeatureEnabled,
        isClassificationEnabled: isClassificationEnabled,
        push: push,
        webItems: webItemLocation?.webItems || [],
        switchToLivePage: switchToLivePage,
        showCommentsPanel: showCommentsPanel
    });
});

});
parcelRegister("kqvQA", function(module, exports) {

$parcel$export(module.exports, "ContentPropertiesQuery", () => $65e63a8a734d713c$export$4ea7a3f4ac83fe8b);
$parcel$export(module.exports, "ContentPropertiesQueryWithBodyRepresentation", () => $65e63a8a734d713c$export$3fec1b8531f6a124);

var $d2LG0 = parcelRequire("d2LG0");
const $65e63a8a734d713c$export$4ea7a3f4ac83fe8b = (0, $d2LG0.default)`query ContentPropertiesQuery($contentId:ID$versionOverride:Int){content(id:$contentId version:$versionOverride){nodes{id type properties(key:"editor"){nodes{id key value}}operations{operation targetType}}}}`;
const $65e63a8a734d713c$export$3fec1b8531f6a124 = (0, $d2LG0.default)`query ContentPropertiesQuery($contentId:ID$versionOverride:Int){content(id:$contentId version:$versionOverride){nodes{id type properties(key:"editor"){nodes{id key value}}operations{operation targetType}body{dynamic{representation}}metadata{frontend{fabricEditorSupported}}}}}`;

});

parcelRegister("b6AjJ", function(module, exports) {

$parcel$export(module.exports, "useCompanyHubSettingsGroupMenuItems", () => $d12f14fcd1ce1fef$export$6509bc85392c811e);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $dAYOx = parcelRequire("dAYOx");
var $ahaN7 = parcelRequire("ahaN7");

var $6fjxX = parcelRequire("6fjxX");

var $jq4tF = parcelRequire("jq4tF");
var $lOeVN = parcelRequire("lOeVN");

var $cEgMD = parcelRequire("cEgMD");
const $d12f14fcd1ce1fef$var$i18n = (0, $2nPZH.defineMessages)({
    shareFeedback: {
        id: "editor-ellipsis-dropdown.open.ellipsis.hub.share-feedback",
        defaultMessage: "Give feedback on Company hub"
    }
});
function $d12f14fcd1ce1fef$export$6509bc85392c811e({ spaceKey: spaceKey }) {
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const openFeedbackCollector = (0, $lOeVN.useFeedbackCollector)({
        source: 'hubEditorEllipsisDropdown',
        type: (0, $jq4tF.FeedbackType).COMPANY_HUB
    });
    return (0, $gwFzn.useCallback)((menuItems)=>{
        if (!isCompanyHub) return;
        menuItems.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ahaN7.default), {
            hasSeparator: menuItems.length >= 1,
            key: "company-hub-settings-items"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
            key: "share-feedback",
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6fjxX))), {
                label: ""
            }),
            onClick: openFeedbackCollector
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $d12f14fcd1ce1fef$var$i18n.shareFeedback))));
    }, [
        isCompanyHub,
        openFeedbackCollector
    ]);
}

});

parcelRegister("aFeyZ", function(module, exports) {

let $7c3907ac92ec977a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $7c3907ac92ec977a$var$load("1vHyq"),
    $7c3907ac92ec977a$var$load("8yyrA"),
    $7c3907ac92ec977a$var$load("zKI0V")
]).then(()=>parcelRequire('6LL3k'));

});



//# sourceMappingURL=EllipsisDropdown.cbca83f3.js.map
